import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CirclePerson from './icon-circle-person.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CirclePerson {...validProps} />;
}
SvgComponent.iconName = 'circlePerson';

/**
 * @deprecated This is a legacy icon
 */
export const CirclePersonIcon = svgIconWrapper(SvgComponent);
